import axiosServices from "utils/axios";

export const getMe = async () => {
  const response = await axiosServices.get(`/me`, {
    headers: {
      Accept: "application/json",
    },
  });
  return response.data;
};

export const loginUser = async (email: string, password: string) => {
  try {
    const response = await axiosServices.post(
      "/login",
      {
        username: email,
        password: password,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      },
    );
    return response;
  } catch (error: any) {
    return error.response;
  }
};

export const logoutUser = async () => {
  await axiosServices.post(
    `/logout`,
    {},
    {
      headers: {
        Accept: "application/json",
      },
      withCredentials: true,
    },
  );
};
